import Services from './services';
import Config from '../Config';

const PermissionsModel = {
    get_my_permissions: () => {
        return Services.getApi(Config.getAuthBasePath() + '/my-permissions');
    },
};

export default PermissionsModel;
